import { ComparablesLayer } from "react-migration/domains/comparables/components/MapLayer/ComparablesLayer";
import { MeasurementSystem } from "src/js/stores/user/store";
import {
  ComparableTileProperties,
  ComparablesFilterOptions,
  CorePriceModes,
  createFilters,
} from "react-migration/domains/comparables";
import { disabledEPCFields } from "react-migration/domains/comparables/util/DisabledFilters";
import { hiddenFieldsByFeature } from "react-migration/domains/comparables/util/hiddenFields";

export type ComparablesLayerConfig = {
  unitPreference: MeasurementSystem;
  visibleIds: Set<string>;
  priceMode: CorePriceModes;
  filterOptions: ComparablesFilterOptions;
};

export const excludedFields = new Set([
  ...disabledEPCFields,
  ...hiddenFieldsByFeature.flatMap(([hasFeature, hiddenFields]) =>
    hasFeature() ? Array.from(hiddenFields) : []
  ),
]);

export const buildComparablesLayer = ({
  unitPreference,
  visibleIds,
  priceMode,
  filterOptions,
}: ComparablesLayerConfig) => {
  const onlyShowVisibleIds = ({ transaction_id }: ComparableTileProperties) => {
    return visibleIds.has(transaction_id);
  };

  const filterFunctions: ((c: ComparableTileProperties) => boolean)[] = [
    ...createFilters(filterOptions, excludedFields),
    onlyShowVisibleIds,
  ];

  return new ComparablesLayer({
    id: "comparables",
    minZoom: 10,
    maxZoom: 18,
    unitPreference,
    priceMode,
    filterFunctions,
  });
};
